import { UserSearchState } from "@users/models/user-search.state";
import { createReducer, on } from "@ngrx/store";
import * as UserSearchActions from "@users/store/actions/user-search.actions";

export const initialState: UserSearchState = {
  searchResult: [],
  searchTerm: "",
  loading: false,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(UserSearchActions.search, (state, { searchTerm: mail }): UserSearchState => ({
    ...state,
    searchTerm: mail,
    loading: true,
    loaded: false
  })),
  on(UserSearchActions.searchSuccess, (state, { users }): UserSearchState => ({
    ...state,
    searchResult: users,
    loading: false,
    loaded: true
  })),
  on(UserSearchActions.searchFailure, (state, {}): UserSearchState => ({
    ...state,
    loading: false,
    loaded: false
  }))
);
